import { PALETTE } from '../StageData';
import { ShadingPipeline } from '../../engine/ShadingPipeline';
import type { ShapeDrawFn } from './furnitureShapes';

export const toyDrawFns: Record<number, ShapeDrawFn> = {
  // STAGE 41: レトロトイ・ロボット
  41: (ctx, cx, cy, mode) => {
    const drawHead = () => {
      ctx.beginPath(); ctx.roundRect(cx - 50, cy - 140, 100, 75, 10);
    };
    const drawBody = () => {
      ctx.beginPath(); ctx.roundRect(cx - 65, cy - 45, 130, 115, 12);
    };
    const drawLimbs = () => {
      ctx.beginPath();
      ctx.roundRect(cx - 50, cy + 70, 35, 75, 6);
      ctx.roundRect(cx + 15, cy + 70, 35, 75, 6);
      ctx.roundRect(cx - 95, cy - 35, 25, 90, 8);
      ctx.roundRect(cx + 70, cy - 35, 25, 90, 8);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      drawLimbs(); ctx.fill(); drawBody(); ctx.fill(); drawHead(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawLimbs(); ctx.stroke();
        drawBody(); ctx.stroke();
        drawHead(); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx - 22, cy - 100, 12, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx + 22, cy - 100, 12, 0, Math.PI * 2); ctx.stroke();
        ctx.strokeRect(cx - 35, cy - 15, 70, 45);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 180, 280, PALETTE.dark, 'metallic');
      drawLimbs(); ctx.fill(); drawBody(); ctx.fill(); drawHead(); ctx.fill();
      ctx.fillStyle = PALETTE.yellow;
      ctx.beginPath(); ctx.arc(cx - 22, cy - 100, 12, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 22, cy - 100, 12, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.red;
      ctx.fillRect(cx - 35, cy - 15, 70, 45);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 25, cy - 120, 25, 12, 0.55);
    }
  },

  // STAGE 42: ビンテージ・カメラ
  42: (ctx, cx, cy, mode) => {
    const drawBody = () => {
      ctx.beginPath(); ctx.roundRect(cx - 110, cy - 65, 220, 130, 14);
    };
    const drawLens = () => {
      ctx.beginPath(); ctx.arc(cx, cy + 5, 55, 0, Math.PI * 2);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawBody(); ctx.fill();
      ctx.fillStyle = '#FAF8F5'; drawLens(); ctx.fill();
      ctx.fillRect(cx - 80, cy - 90, 40, 25);
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawBody(); ctx.stroke();
        drawLens(); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy + 5, 38, 0, Math.PI * 2); ctx.stroke();
        ctx.strokeRect(cx - 80, cy - 90, 40, 25);
        ctx.strokeRect(cx + 50, cy - 85, 25, 20);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 220, 130, PALETTE.silver, 'metallic');
      drawBody(); ctx.fill();
      ctx.fillStyle = PALETTE.dark; ctx.fillRect(cx - 110, cy - 35, 220, 70);
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 5, 110, 110, PALETTE.dark, 'metallic');
      drawLens(); ctx.fill();
      ctx.fillStyle = PALETTE.cyan;
      ctx.beginPath(); ctx.arc(cx, cy + 5, 38, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 12, cy - 8, 20, 20, 0.65);
    }
  },

  // STAGE 43: RCドリフトカー
  43: (ctx, cx, cy, mode) => {
    const drawBuggy = () => {
      ctx.beginPath();
      ctx.moveTo(cx - 130, cy + 20);
      ctx.lineTo(cx - 110, cy - 30);
      ctx.lineTo(cx - 40, cy - 50);
      ctx.lineTo(cx + 70, cy - 30);
      ctx.lineTo(cx + 130, cy + 20);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawBuggy(); ctx.fill();
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.arc(cx - 85, cy + 45, 32, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 85, cy + 45, 32, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawBuggy(); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx - 85, cy + 45, 32, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx + 85, cy + 45, 32, 0, Math.PI * 2); ctx.stroke();
        ctx.strokeRect(cx - 130, cy - 65, 30, 25);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = PALETTE.black;
      ctx.beginPath(); ctx.arc(cx - 85, cy + 45, 32, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 85, cy + 45, 32, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 10, 260, 80, PALETTE.cyan, 'lacquer');
      drawBuggy(); ctx.fill();
      ctx.fillStyle = PALETTE.purple;
      ctx.beginPath(); ctx.roundRect(cx - 30, cy - 45, 60, 30, 6); ctx.fill();
      ctx.fillStyle = PALETTE.yellow; ctx.fillRect(cx - 130, cy - 65, 30, 25);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 20, cy - 25, 45, 12, 0.55);
    }
  },

  // STAGE 44: レトロアーケード筐体
  44: (ctx, cx, cy, mode) => {
    const drawCab = () => {
      ctx.beginPath();
      ctx.moveTo(cx - 65, cy - 140);
      ctx.lineTo(cx + 65, cy - 140);
      ctx.lineTo(cx + 65, cy + 150);
      ctx.lineTo(cx - 65, cy + 150);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawCab(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawCab(); ctx.stroke();
        ctx.strokeRect(cx - 55, cy - 130, 110, 35);
        ctx.strokeRect(cx - 50, cy - 80, 100, 75);
        ctx.strokeRect(cx - 55, cy + 10, 110, 40);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 130, 290, PALETTE.dark, 'metallic');
      drawCab(); ctx.fill();
      ctx.fillStyle = PALETTE.crimson; ctx.fillRect(cx - 55, cy - 130, 110, 35);
      ctx.fillStyle = PALETTE.cyan; ctx.fillRect(cx - 50, cy - 80, 100, 75);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 20, cy - 60, 25, 25, 0.45);
    }
  },

  // STAGE 45: ドールハウス
  45: (ctx, cx, cy, mode) => {
    const drawHouse = () => {
      ctx.beginPath();
      ctx.moveTo(cx, cy - 140);
      ctx.lineTo(cx + 105, cy - 40);
      ctx.lineTo(cx + 105, cy + 140);
      ctx.lineTo(cx - 105, cy + 140);
      ctx.lineTo(cx - 105, cy - 40);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawHouse(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawHouse(); ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(cx, cy - 140); ctx.lineTo(cx - 105, cy - 40);
        ctx.moveTo(cx, cy - 140); ctx.lineTo(cx + 105, cy - 40);
        ctx.stroke();
        ctx.strokeRect(cx - 25, cy + 50, 50, 90);
        ctx.strokeRect(cx - 80, cy - 15, 40, 40);
        ctx.strokeRect(cx + 40, cy - 15, 40, 40);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 50, 210, 180, PALETTE.ivory, 'wood');
      ctx.fillRect(cx - 105, cy - 40, 210, 180);
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 90, 210, 100, PALETTE.pink, 'wood');
      ctx.beginPath(); ctx.moveTo(cx, cy - 140); ctx.lineTo(cx + 105, cy - 40); ctx.lineTo(cx - 105, cy - 40); ctx.closePath(); ctx.fill();
      ctx.fillStyle = PALETTE.emerald; ctx.fillRect(cx - 25, cy + 50, 50, 90);
    }
  },

  // STAGE 46: 真鍮の天体望遠鏡
  46: (ctx, cx, cy, mode) => {
    const drawTube = () => {
      ctx.beginPath();
      ctx.moveTo(cx - 120, cy - 90); ctx.lineTo(cx + 130, cy + 10); ctx.lineTo(cx + 120, cy + 40); ctx.lineTo(cx - 130, cy - 60); ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawTube(); ctx.fill();
      ctx.beginPath(); ctx.moveTo(cx, cy - 10); ctx.lineTo(cx - 95, cy + 150); ctx.lineTo(cx + 95, cy + 150); ctx.stroke();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawTube(); ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(cx, cy - 10); ctx.lineTo(cx - 95, cy + 150);
        ctx.moveTo(cx, cy - 10); ctx.lineTo(cx + 95, cy + 150);
        ctx.stroke();
        ctx.strokeRect(cx - 140, cy - 100, 25, 50);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = PALETTE.darkWood;
      ctx.beginPath(); ctx.moveTo(cx, cy - 10); ctx.lineTo(cx - 95, cy + 150); ctx.lineTo(cx + 95, cy + 150); ctx.stroke();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 25, 260, 100, PALETTE.brass, 'metallic');
      drawTube(); ctx.fill();
      ctx.fillStyle = PALETTE.gold; ctx.fillRect(cx - 140, cy - 100, 25, 50);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 10, cy - 40, 55, 14, 0.65);
    }
  },

  // STAGE 47: パズルキューブ
  47: (ctx, cx, cy, mode) => {
    const drawCube = () => {
      ctx.beginPath(); ctx.moveTo(cx, cy - 110); ctx.lineTo(cx + 95, cy - 55); ctx.lineTo(cx, cy); ctx.lineTo(cx - 95, cy - 55); ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawCube(); ctx.fill();
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.moveTo(cx - 95, cy - 55); ctx.lineTo(cx, cy); ctx.lineTo(cx, cy + 105); ctx.lineTo(cx - 95, cy + 50); ctx.closePath(); ctx.fill();
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.moveTo(cx + 95, cy - 55); ctx.lineTo(cx, cy); ctx.lineTo(cx, cy + 105); ctx.lineTo(cx + 95, cy + 50); ctx.closePath(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawCube(); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(cx - 95, cy - 55); ctx.lineTo(cx, cy); ctx.lineTo(cx, cy + 105); ctx.lineTo(cx - 95, cy + 50); ctx.closePath(); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(cx + 95, cy - 55); ctx.lineTo(cx, cy); ctx.lineTo(cx, cy + 105); ctx.lineTo(cx + 95, cy + 50); ctx.closePath(); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 55, 190, 110, PALETTE.yellow, 'lacquer');
      drawCube(); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx - 47, cy + 25, 95, 160, PALETTE.red, 'lacquer');
      ctx.beginPath(); ctx.moveTo(cx - 95, cy - 55); ctx.lineTo(cx, cy); ctx.lineTo(cx, cy + 105); ctx.lineTo(cx - 95, cy + 50); ctx.closePath(); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx + 47, cy + 25, 95, 160, PALETTE.deepBlue, 'lacquer');
      ctx.beginPath(); ctx.moveTo(cx + 95, cy - 55); ctx.lineTo(cx, cy); ctx.lineTo(cx, cy + 105); ctx.lineTo(cx + 95, cy + 50); ctx.closePath(); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx, cy - 55, 45, 18, 0.45);
    }
  },

  // STAGE 48: ゼンマイ仕掛けの車
  48: (ctx, cx, cy, mode) => {
    const drawCar = () => {
      ctx.beginPath(); ctx.roundRect(cx - 105, cy - 20, 210, 80, 16);
      ctx.arc(cx - 10, cy - 20, 55, Math.PI, 0);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawCar(); ctx.fill();
      ctx.beginPath(); ctx.arc(cx - 60, cy + 60, 24, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 60, cy + 60, 24, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx, cy - 90, 22, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawCar(); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx - 60, cy + 60, 24, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx + 60, cy + 60, 24, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy - 90, 22, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(cx, cy - 75); ctx.lineTo(cx, cy - 55);
        ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = PALETTE.black;
      ctx.beginPath(); ctx.arc(cx - 60, cy + 60, 24, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 60, cy + 60, 24, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 10, 210, 100, PALETTE.crimson, 'lacquer');
      drawCar(); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 90, 44, 44, PALETTE.gold, 'metallic');
      ctx.beginPath(); ctx.arc(cx, cy - 90, 22, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 25, cy - 35, 30, 15, 0.55);
    }
  },

  // STAGE 49: 木製プロヨーヨー
  49: (ctx, cx, cy, mode) => {
    const drawYoYo = () => {
      ctx.beginPath(); ctx.arc(cx, cy, 110, 0, Math.PI * 2);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawYoYo(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawYoYo(); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy, 80, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy, 30, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 220, 220, PALETTE.crimson, 'lacquer');
      drawYoYo(); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 160, 160, PALETTE.wood, 'wood');
      ctx.beginPath(); ctx.arc(cx, cy, 80, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 60, 60, PALETTE.gold, 'metallic');
      ctx.beginPath(); ctx.arc(cx, cy, 30, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 35, cy - 35, 35, 35, 0.5);
    }
  },

  // STAGE 50: ガチャガチャマシン
  50: (ctx, cx, cy, mode) => {
    const drawGacha = () => {
      ctx.beginPath();
      ctx.arc(cx, cy - 50, 90, 0, Math.PI * 2);
      ctx.roundRect(cx - 85, cy + 30, 170, 125, 16);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawGacha(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawGacha(); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy + 70, 22, 0, Math.PI * 2); ctx.stroke();
        ctx.strokeRect(cx - 30, cy + 110, 60, 35);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 92, 170, 125, PALETTE.crimson, 'lacquer');
      ctx.fillRect(cx - 85, cy + 30, 170, 125);
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 50, 180, 180, PALETTE.cyan, 'glass');
      ctx.beginPath(); ctx.arc(cx, cy - 50, 90, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.white;
      ctx.beginPath(); ctx.arc(cx, cy + 70, 22, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 35, cy - 80, 35, 35, 0.65);
    }
  }
};
